import { render } from "./OrderStatusProgressBar.vue?vue&type=template&id=af4894dc"
import script from "./OrderStatusProgressBar.vue?vue&type=script&lang=js"
export * from "./OrderStatusProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__